module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_1.9e0d47f9.png";